import { TCol } from "../../../../../../../../../components/layout/listing-table/listing-table.types";
import {
  Date,
  UserName,
} from "../../../../../../../../../components/layout/listing-table/listing-table-render-components";
import { IAssetsTableColumnsOptions } from "../../../../../../../../../features/file-attachments/file-upload/components/file-upload-assets-table/types/file-upload-assets-table.interface";
import { renderFileLink } from "../../../../../../../../../features/file-attachments/file-upload/components/file-upload-assets-table/components/file-link/file-link.functions";
import { IAsset } from "../../../../../../../../../features/file-attachments/types/file-attachment.interface";

import { FlyerDetailPageAssetsState } from "./flyer-detail-page-assets.interface";

export function createFlyerDetailPageAssetsState(): FlyerDetailPageAssetsState {
  return {
    assets: null,
    isLoading: false,
    error: null,
  };
}

export const getFlyerDetailPageAssetTableColumns = (
  options: IAssetsTableColumnsOptions
): TCol[] => [
  {
    label: "File",
    key: "url",
    render: (row) => renderFileLink(row as IAsset, options.canDownload),
  },
  { label: "Uploaded by", key: "ownerDetails", render: (row) => UserName(row.owner) },
  {
    label: "Upload Date",
    key: "createdAt",
    render: (row) => Date(row.createdAt, "MMM DD, H:mm:ss"),
  },
];
